import { Store, AnyAction } from 'redux'
import { ReduxState } from '@/config/redux/types'
import { selectUserLocale } from '@/redux/userConfig/selectors'
import { selectActiveStepIndex } from '@/redux/signup/selectors'
import { observeStore } from '@/redux/utils'
import trackLocaleChange from './trackLocaleChange'
import trackPageView from './trackPageView'
import { getState } from '@/config/redux'

interface Props {
  store: Store<ReduxState, AnyAction>
}

const Tracker = ({ store }: Props) => {
  const state = getState()
  const activeStepIndex = selectActiveStepIndex(state)

  // Track the initial page view as it only will track when it changes.
  trackPageView(activeStepIndex)

  observeStore<string>(store, selectUserLocale, trackLocaleChange)
  observeStore<number>(store, selectActiveStepIndex, trackPageView)

  return null
}

export default Tracker
